import { formatDate } from '@angular/common';

/**
 * DateUtil
 *
 * 日付変換用クラス
 * アプリ内のDateの取り回しをDate型とString型どちらにするか決定する必要がある
 * 　→ 一旦アプリ内はDateで取り回す
 * Dateの変換はViewかDAOで行う予定
 */
export class DateUtil {

	/**
	 * convertString2Date
	 * 文字列を日付オブジェクトにする。
	 * コンストラクタにそのまま文字列を入れるとUTCになるが、ばらして入れるとJSTになる。
	 * @param data 日付文字列 yyyy-mm-dd じゃないとだめ。
	 */
	public static string2Date(data: string): Date{

		// 空ならnull を返す
		if(!data) { return null;}

		// 分解。「-」 直指定なので注意
		const sepLst = data.split('-');
		if (sepLst.length !== 3) {
			return null;
		};
		// date作成。月が０からなので-1する
		const date = new Date( Number(sepLst[0]), Number(sepLst[1]) - 1, Number(sepLst[2]),);

		return date;
	}



	/**
	 * formatJaDateTime
	 * Date型のFormatを行う
	 * @param dateOrg 元のDate
	 * @param fmt 日付フォーマット
	 * @returns string
	 */
	private static formatJaDateTimeString(dateOrg: Date, fmt: string): string {
		const dateFormat = formatDate(dateOrg, fmt, 'ja');
		return dateFormat;
	}

	/**
	 * getNowDateTimeString
	 * 現在の日付時刻を取得する
	 * @returns string
	 */
	public static getNowDateTimeString(): string {
		return this.formatJaDateTimeString(new Date(), 'yyyy-MM-dd HH:mm:ss');
	}

	/**
	 * getNowDateString
	 * 現在の日付を取得
	 * @returns string
	 */
	public static getNowDateString(): string {
		return this.formatJaDateTimeString(new Date(), 'yyyy-MM-dd');
	}

	/**
	 * getDateString
	 * 指定DateオブジェクトからJSTをStringで取得
	 * @returns string
	 */
	public static getDateString(target: Date): string {
		return this.formatJaDateTimeString(target, 'yyyy-MM-dd');
	}
	/**
	 * getNowDateTimeString
	 * 指定DateオブジェクトからJSTをStringで取得
	 * @returns string
	 */
	 public static getDateTimeString(target: Date): string {
		return this.formatJaDateTimeString(target, 'yyyy-MM-dd HH:mm:ss');
	}
	public static getDateTimeStringFromString(target: string): string {
		const dateVal = new Date(target); // HACK: 文字列パースはダメなので、後でなんとかする
		if ( target && dateVal) { // 日付時刻にできたら文字列にして返す
			return DateUtil.getDateTimeString( dateVal );
		}
		return '';
	}




	/**
	 * calculateAgeFromBirthday
	 *
	 * 誕生日から年齢を計算する
	 * @param birthday 誕生日
	 * @returns 年齢
	 */
	public static calculateAgeFromBirthday(birthday: string) {

		if (!birthday) {return '';}

		// 文字列に分解
		const date = new Date(birthday);
		const y2 = date.getFullYear().toString().padStart(4, '0');
		const m2 = (date.getMonth() + 1).toString().padStart(2, '0');
		const d2 = date.getDate().toString().padStart(2, '0');

		// 今日の日付
		const today = new Date();
		const y1 = today.getFullYear().toString().padStart(4, '0');
		const m1 = (today.getMonth() + 1).toString().padStart(2, '0');
		const d1 = today.getDate().toString().padStart(2, '0');

		// 引き算
		const age = Math.floor((Number(y1 + m1 + d1) - Number(y2 + m2 + d2)) / 10000);

		return age;

	}
}
